import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, TextField, IconButton, Typography, MenuItem, Select, FormControl, InputLabel, CardContent, Grid, Skeleton, Box, Chip, Divider } from '@mui/material';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate } from '@fortawesome/free-solid-svg-icons';
import Pagination from '@mui/material/Pagination';
import { post } from '../../../../_helper/api_helper';
import AnnouncementDetail from '../Announcement/AnnouncementDetail';
import { faSearch } from '@fortawesome/pro-duotone-svg-icons';
import { size } from 'lodash';
import CountdownTimer from '../Announcement/CountdownTimer';

const GAList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [dataLoader,setDataLoader] = useState(false)
  const [toggleApi,setToggleApi] = useState(false)

  const fetchData = async (pageNumber = 1, pageSize = itemsPerPage, searchTerm="") => {
    const url = `${process.env.REACT_APP_API_DOTNET_URL}/PMISAdvanceSearch/pmis-global?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    let whereCondition = searchTerm?`Announcement_id LIKE '%${searchTerm}%' OR POSITION_NO LIKE '%${searchTerm}%' OR PositionTitle LIKE '%${searchTerm}%'` :""
    const payload = {
      tableName: "Eligibility-Summary",
      searchParams: "[]",
      columns: "*",
      location: "pmis-global",
      pageNumber,
      pageSize,
      sortData: "",
      additionalWhere: whereCondition,
      qID: 0
    };
    setDataLoader(true)
    try {
      const response = await post(url, payload);
      console.log(response, "response1221werre");
      setData(response?.results);
      setFilteredData(response?.results);
      setTotalItems(response?.rowCount);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally{
      setDataLoader(false)
    }
  };

  useEffect(() => {
    // fetchData(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
    //   const lowercasedSearchTerm = searchTerm.toLowerCase();
    //   setFilteredData(
    //     data.filter((item) =>
    //       item.General_Availibility_ID.toLowerCase().includes(lowercasedSearchTerm)
    //     )
    //   );
    fetchData(currentPage, itemsPerPage, searchTerm);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, currentPage,itemsPerPage, toggleApi]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const displayedData = filteredData;

  return (
    <div style={{ padding: "0px" }}>
        {/* <CountdownTimer targetDate={"2024-06-23T00:00:00"} label="Elapsed Time Countdown" /> */}
      <Row className="bg-primary rounded py-2 mb-3 sticky-top">
        <Col className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faCertificate} size="xl" />
          <Typography variant="h6" style={{ color: "white" }}>
            Announcement-General Availability
          </Typography>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FontAwesomeIcon
              icon={faSearch}
              style={{
                position: "absolute",
                left: "22px",
                zIndex: 1,
                color: "blue",
                fontSize: "18px",
              }}
            />
            <TextField
              variant="outlined"
              placeholder="Announcement, Position No, Position Name ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                borderRadius: "20px",
                marginLeft: "10px",
                backgroundColor: "white",
                paddingLeft: "40px", // to make space for the search icon
                width: "550px",
              }}
              InputProps={{
                style: { borderRadius: "20px" },
              }}
              size="small"
            />
          </div>
        </Col>
      </Row>
      <div style={{ overflowY: "auto", maxHeight: "60vh" }}>
        {dataLoader
          ? ["1", "2"].map((item, key) => (
              <Card sx={{ margin: "auto", mt: 5 }} key={item}>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                      <Skeleton variant="text" width="60%" height={40} />
                      <Skeleton variant="text" width="40%" />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <Chip
                        label={<Skeleton variant="text" width={40} />}
                        color="default"
                      />
                    </Grid>
                  </Grid>
                  <Divider sx={{ my: 2 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="70%" />
                      <Skeleton variant="text" width="90%" />
                      {/* <Skeleton variant="text" width="80%" />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="50%" /> */}
                    </Grid>
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="70%" />
                      <Skeleton variant="text" width="90%" />
                      {/* <Skeleton variant="text" width="80%" />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="50%" /> */}
                    </Grid>
                  </Grid>
                  {/* <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
            <Skeleton variant="circular" width={24} height={24} />
            <Box display="flex" alignItems="center">
              <Skeleton variant="text" width={100} />
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          </Box>
          <Box display="flex" justifyContent="center" mt={2}>
            <Skeleton variant="circular" width={80} height={80} />
          </Box> */}
                  <Grid container justifyContent="space-around" mt={2}>
                    <Grid item>
                      <Chip
                        label={<Skeleton variant="text" width={40} />}
                        color="default"
                        size="small"
                      />
                    </Grid>
                    <Grid item>
                      <Chip
                        label={<Skeleton variant="text" width={40} />}
                        color="default"
                        size="small"
                      />
                    </Grid>
                    <Grid item>
                      <Chip
                        label={<Skeleton variant="text" width={40} />}
                        color="default"
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ))
          : displayedData.map((item, index) => (
              <AnnouncementDetail
                key={index}
                id={item.General_Availibility_ID}
                cardData={item}
                setToggleApi={setToggleApi}
              />
            ))}
      </div>
      {displayedData?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "10px",
            position: "sticky",
            bottom: "0",
            backgroundColor: "white",
            padding: "5px",
          }}
        >
          <FormControl variant="outlined" style={{ minWidth: 120 }}>
            <InputLabel>Items per page</InputLabel>
            <Select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              label="Items per page"
              size="small"
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
          </FormControl>
          <Pagination
            count={Math.ceil(totalItems / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
          />
        </div>
      )}
      {displayedData.length == 0 && !dataLoader && (
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <h5>No records found</h5>
        </div>
      )}
    </div>
    
  );
};

export default GAList;
